import React, { Component } from 'react';

export default class TwoFactor extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}
	sendConfirmationEmail = () => {
		fetch(window.location.origin + window.location.pathname + 'sendtwofactoremail', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.setData('twoFactorMethod', 'Email')
			} else {
				this.setState({ twoFactorError: await response.text() })
			}

		})
	}

	confirmEmail = () => {
		fetch(window.location.origin + window.location.pathname + 'confirmtwofactoremail', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.confirmTwoFactor(await response.json())
			} else {
				this.setState({ twoFactorError: await response.text() })
			}
		})
	}

	sendConfirmationSMS = () => {
		fetch(window.location.origin + window.location.pathname + 'sendtwofactorsms', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.setData('twoFactorMethod', 'SMS')
			} else {
				this.setState({ twoFactorError: await response.text() })
			}
		})
	}

	confirmSMS = () => {
		fetch(window.location.origin + window.location.pathname + 'confirmtwofactorsms', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
			if (response.status == 200) {
				this.props.confirmTwoFactor(await response.json())
			} else {
				this.setState({ twoFactorError: await response.text() })
			}
		})
	}

	render() {
		return (
			<div style={{ textAlign: 'center', overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Two Factor Authentication</h3>
				<hr />
				<p>Would you like to receive a code via email or SMS message?</p>
				<div className="toggle">
					<div className={this.props.data.twoFactorMethod == 'Email' ? 'Selected' : 'NotSelected'} onClick={this.sendConfirmationEmail}>Email</div>
					<div className={this.props.data.twoFactorMethod == 'SMS' ? 'Selected' : 'NotSelected'} onClick={this.sendConfirmationSMS}>SMS</div>
				</div>

				{this.state.twoFactorError ? <div className="error">{this.state.twoFactorError}</div> : ''}

				{this.props.data.twoFactorMethod == 'Email' ?
					<div>
						<h5 style={{ padding: '0px 15px', maxWidth: '600px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>A confirmation email has been sent to {this.props.data.Email}. Please enter the confirmation code in the box below.</h5>

						<p>Email Confirmation Code</p>
						<input type="text" key="EmailConfirmation" value={this.props.data.EmailConfirmation} onChange={(e) => { this.props.setData('EmailConfirmation', e.currentTarget.value) }} />

						<div className="button" style={this.props.data.EmailConfirmation && this.props.data.EmailConfirmation.length == 6 ? {} : { backgroundColor: '#888' }} onClick={this.confirmEmail}>Confirm</div>
					</div>
					: this.props.data.twoFactorMethod == 'SMS' ?
						<div>
							<h5 style={{ padding: '0px 15px', maxWidth: '500px', textAlign: 'justify', color: '#555', fontWeight: 300 }}>A confirmation text message has been sent to {this.props.data.Phone}. Please enter the confirmation code in the box below.</h5>

							<p>SMS Confirmation Code</p>
							<input type="text" value={this.props.data.PhoneConfirmation} onChange={(e) => { this.props.setData('PhoneConfirmation', e.currentTarget.value) }} />

							<div className="button" style={this.props.data.PhoneConfirmation && this.props.data.PhoneConfirmation.length == 6 ? {} : { backgroundColor: '#888' }} onClick={this.confirmSMS}>Confirm</div>
						</div>
						: ''}

			</div>
		);

	}
}